<template>
  <div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fields"
          :actions="actions"
          :items="lstSolicitacoesTDeficiencia"
          responsive
          sortBy="idsolicitacao"
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titlePDF"
          :titlePDF="titlePDF"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="complementoEspecifica"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      size="lg"
      travaBack
      @close="criar = {}"
      ><fcc-complemento-solicitacao
        :solicitacao="complemento"
        v-if="complemento.idsolicitacao != null"
      />
    </fccModal>
    <fccModal
      centered
      idModal="regrasTipoDeficiencia"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      size="lg"
      travaBack
      @close="complemento = {}"
    >
      <fcc-exclusao-solicitacao
        :solicitacao="complemento"
        v-if="complemento.idsolicitacao != null"
      />
    </fccModal>
  </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'
import FccComplementoSolicitacao from './FccComplementoSolicitacao.vue'
import FccExclusaoSolicitacao from './FccExclusaoSolicitacao.vue'
export default {
  data() {
    return {
      itemPorPage: 100,
      titleModal: '',
      lstSolicitacaoEspecifica: [],
      complemento: {},
      solicitaItem: '',
      lstSolicitacoesTDeficiencia: [],
      titlePDF: 'Solicitações Específicas',
      fields: [
        {
          key: 'idtipodeficienciasolicitacaopublicacao',
          label: 'ID',
          sortable: true,
          active: true
        },
        { key: 'solicitacao', label: 'Solicitação Específica', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editComplementos',
          icon: 'list',
          tooltip: 'Complementos',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'editRegrasExclusao',
          icon: 'list',
          tooltip: 'Regras de Exclusão',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteTSolicitacaoEspecifica',
          icon: 'trash',
          tooltip: 'Deletar',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    tipodeficiencia: {
      type: Object,
      require: true
    }
  },
  components: {
    FccComplementoSolicitacao,
    FccExclusaoSolicitacao
  },
  methods: {
    editComplementos(_, item) {
      this.titleModal = 'Complementos - Solicitação Específica - ' + item.solicitacao
      this.complemento = { ...item }
      this.$root.$emit('bv::show::modal', 'complementoEspecifica')
    },
    editRegrasExclusao(_, item) {
      this.titleModal = 'Regras de Exclusão - Solicitação Específica - ' + item.solicitacao
      this.complemento = { ...item }
      this.$root.$emit('bv::show::modal', 'regrasTipoDeficiencia')
    },
    deleteTSolicitacaoEspecifica(_, item) {
      this.callConfirm(this.mensagemExcluir, item.solicitacao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlLaudoMedico +
                'TipoDeficienciaSolicitacaoCondicaoEspecificaPublicacao/Excluir/' +
                item.idtipodeficienciasolicitacaopublicacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.sucessoSituacao(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto)
        }
      })
    },
    sucessoSituacao(texto) {
      this.solicitaItem = ''
      this.listaSolicitacaoEspecificaTDeficiencia()
      this.callToast(texto)
    },
    adicionarSolicitacao(item) {
      const verifica = this.lstSolicitacoesTDeficiencia.find(
        (e) => e.idsolicitacao == item.idsolicitacao
      )
      if (verifica != null) {
        this.callAlert('Já consta na lista', item.solicitacao, 'error', 'error')
        return
      }
      const addT = {
        idtipodeficienciasolicitacao: 0,
        tpdeficiencia: this.tipodeficiencia.tpdeficiencia,
        idsolicitacao: item.idsolicitacao,
        cdfuncionario: this.dadosUserSession.usuCdFuncionario
      }
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlLaudoMedico + 'TipoDeficienciaSolicitacaoCondicaoEspecifica/Adicionar',
          addT,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.sucessoSituacao(this.mensagensUpdate.adicionado)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listaSolicitacaoEspecificaTDeficiencia() {
      this.TipoDeficienciaSolicitacaoCondicaoEspecificaPublicacao(
        this.tipodeficiencia.tpdeficienciapublicacao
      ).then((response) => {
        this.lstSolicitacoesTDeficiencia = response
      })
    }
  },
  mounted() {
    this.listaSolicitacaoEspecificaTDeficiencia()
  }
}
</script>